import { useStoreon } from "storeon/react";
import { ISidebarEvents, ISidebarStore } from "../store/sidebarStore";

export const useSidebarStore = () => {
  const { sidebarStore, dispatch: sidebarDispatch } =
    useStoreon<ISidebarStore, ISidebarEvents>("sidebarStore");

  return { sidebarStore, sidebarDispatch };
};